(() => {
 const root = document.querySelector('[data-bbwl]');
 if (!root) return;
 const host = root.querySelector('#wsg-login');
 if (!host) return;
  const text = {...root.dataset, welcome: 'Wholesale login'};
 // Wholesale Gorilla inserts account forms after DOMContentLoaded.
 // Connect each new form to Shopify's supported CAPTCHA API.
 const protectedForms = new WeakSet();
 const protectAccountForms = () => {
  const captcha = window.Shopify && window.Shopify.captcha;
  if (!captcha || typeof captcha.protect !== 'function') return;
  host.querySelectorAll('form[action*="/account"]').forEach((form) => {
   const formType = form.querySelector('input[name="form_type"]');
   if (!formType || !['customer_login', 'recover_customer_password', 'create_customer'].includes(formType.value) || protectedForms.has(form)) return;
   protectedForms.add(form);
   try {
    captcha.protect(form);
   } catch (error) {
    protectedForms.delete(form);
    console.warn('BBcino: account form CAPTCHA initialization failed.');
   }
  });
 };
 const enhance = () => {
  protectAccountForms();
  const form = host.querySelector('#customer_login');
  if (!form) return false;
  if (form.dataset.bbwlReady) {
   const title = form.querySelector('#wsg-title');
   if(title && title.textContent !== text.welcome) title.textContent = text.welcome;
   return true;
  }
  form.dataset.bbwlReady = 'true';
  let destination=form.querySelector('input[name="return_url"]');if(!destination){destination=document.createElement('input');destination.type='hidden';destination.name='return_url';form.append(destination);}destination.value='/account';
  const title = form.querySelector('#wsg-title');
  if (title) title.textContent = text.welcome;
  const intro = form.querySelector('#wsg-login-desc');
  if (intro) intro.textContent = text.loginIntro;
  const email = form.querySelector('#customer_email');
  if (email) {
   email.autocomplete = 'username'; email.required = true; email.placeholder = 'you@yourstore.com.au';
   email.removeAttribute('data-translation-selector');
   const label = form.querySelector('label[for="customer_email"]');
   if (label) { label.textContent = text.email; label.removeAttribute('data-translation-selector'); }
  }
  const password = form.querySelector('#customer_password');
  if (password) {
   password.autocomplete = 'current-password'; password.required = true;
   const wrap = document.createElement('div'); wrap.className = 'bbwl-password-wrap';
   password.before(wrap); wrap.append(password);
   const toggle = document.createElement('button'); toggle.type = 'button'; toggle.className = 'bbwl-password-toggle';
   toggle.textContent = text.show; toggle.setAttribute('aria-controls', password.id); toggle.setAttribute('aria-pressed', 'false');
   toggle.addEventListener('click', () => {
    const show = password.type === 'password'; password.type = show ? 'text' : 'password';
    toggle.textContent = show ? text.hide : text.show; toggle.setAttribute('aria-pressed', String(show));
   }); wrap.append(toggle);
  }
  const submit = form.querySelector('input[type="submit"]');
  if (submit) { submit.value = text.login; submit.removeAttribute('data-translation-selector'); }
  const signup = form.querySelector('#wsg-signup-link');
  if (signup) {
   const label = signup.querySelector('span'); if (label) { label.textContent = text.new; label.removeAttribute('data-translation-selector'); }
   const link = signup.querySelector('#signupLinkA');
   if (link) { link.textContent = text.apply; link.removeAttribute('data-translation-selector'); }
   form.append(signup);
  }
  const recovery = host.querySelector('#recover-email');
  if (recovery) { recovery.autocomplete = 'email'; recovery.required = true; }
  const loading = root.querySelector('[data-bbwl-loading]'); if (loading) loading.hidden = true;
  return true;
 };
 const observer = new MutationObserver(enhance);
 observer.observe(host, {childList:true,subtree:true});
 enhance();
 const captchaReadyTimer = setInterval(protectAccountForms, 250);
 setTimeout(() => clearInterval(captchaReadyTimer), 15000);
 setTimeout(() => { if (!host.querySelector('#customer_login')) { const fallback=root.querySelector('[data-bbwl-fallback]'); if(fallback) fallback.hidden=false; } },15000);
})();
